import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import UndoIcon from "@mui/icons-material/Undo";
import { useState } from "react";
import { Link } from "react-router-dom";

interface QuotationActionMenuProps {
  row: any;
  handleRevert?: (id: string) => void;
  canChange: boolean;
}

export const QuotationTrashActionMenu = ({
  row,
  handleRevert,
  canChange,
}: QuotationActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          elevation: 3,
          sx: {
            fontFamily: "var(--bs-font-sans-serif) !important",
            "& *": {
              fontFamily: "var(--bs-font-sans-serif) !important",
            },
            "& .MuiMenuItem-root": {
              minHeight: "28px",
              padding: "4px 12px",
            },
            "& .MuiMenuItem-root .MuiListItemText-primary": {
              fontSize: "13px !important",
              fontWeight: "500 !important"
            },
          },
        }}
      >
        <MenuItem
          component={Link}
          to={`/view-trash-quotation/${row.original.quotation_id}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="View"
            sx={{
              fontFamily: "var(--bs-font-sans-serif) !important",
              fontSize: "13px",
            }}
          />
        </MenuItem>

        {canChange && (
          <MenuItem
            onClick={() => {
              if (handleRevert) handleRevert(row.original.quotation_id);
              handleClose();
            }}
            sx={{ color: "error.main" }}
          >
            <ListItemIcon>
              <UndoIcon fontSize="small" color="success" />
            </ListItemIcon>
            <ListItemText
              primary="Revert"
              sx={{
                fontFamily: "var(--bs-font-sans-serif) !important",
                fontSize: "13px",
              }}
            />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
